import { auth, db } from '../firebaseConfig';
import { sendEmailVerification, sendPasswordResetEmail as firebaseSendPasswordResetEmail } from 'firebase/auth';

export const sendWelcomeEmail = async (user, username) => {
  try {
    // Send verification email
    await sendEmailVerification(user, {
      url: 'https://dreamarium.online/verify',
      handleCodeInApp: true
    });

    // Send welcome email using your email service (e.g., SendGrid, AWS SES, etc.)
    // This is a placeholder for the actual email sending implementation
    console.log(`Welcome email sent to ${user.email}`);
  } catch (error) {
    console.error('Error sending welcome email:', error);
    throw error;
  }
};

export const sendPasswordResetEmail = async (email) => {
  try {
    await firebaseSendPasswordResetEmail(auth, email, {
      url: 'https://dreamarium.online/reset-password',
      handleCodeInApp: true
    });
  } catch (error) {
    console.error('Error sending password reset email:', error);
    throw error;
  }
};

export const sendNewDreamNotification = async (user, dreamTitle) => {
  try {
    // Send notification email about new dream
    // This is a placeholder for the actual email sending implementation
    console.log(`New dream notification sent to ${user.email}`);
  } catch (error) {
    console.error('Error sending new dream notification:', error);
    throw error;
  }
};

export const sendDreamInterpretationNotification = async (user, dreamTitle) => {
  try {
    // Send notification email about dream interpretation
    // This is a placeholder for the actual email sending implementation
    console.log(`Dream interpretation notification sent to ${user.email}`);
  } catch (error) {
    console.error('Error sending dream interpretation notification:', error);
    throw error;
  }
};

export const sendProfileUpdateNotification = async (user, updateType) => {
  try {
    // Send notification email about profile updates
    // This is a placeholder for the actual email sending implementation
    console.log(`Profile update notification sent to ${user.email}`);
  } catch (error) {
    console.error('Error sending profile update notification:', error);
    throw error;
  }
};

export const sendCreditPurchaseNotification = async (user, amount, credits) => {
  try {
    // Send notification email about credit purchase
    // This is a placeholder for the actual email sending implementation
    console.log(`Credit purchase notification sent to ${user.email}`);
  } catch (error) {
    console.error('Error sending credit purchase notification:', error);
    throw error;
  }
};

export const sendSubscriptionUpdateNotification = async (user, subscriptionType) => {
  try {
    // Send notification email about subscription changes
    // This is a placeholder for the actual email sending implementation
    console.log(`Subscription update notification sent to ${user.email}`);
  } catch (error) {
    console.error('Error sending subscription update notification:', error);
    throw error;
  }
}; 